import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';

interface IProps {
  isLoading: boolean;
  isOverlay?: boolean;
  children: React.ReactElement;
}

const LoadingContainer = (props: IProps): React.ReactElement => {
  const { isLoading, isOverlay } = props;

  if (isLoading) {
    if (isOverlay) {
      return (
        <>
          <Backdrop open={isLoading} style={{ zIndex: 9001 }}>
            <CircularProgress />
          </Backdrop>
          {props.children || <></>}
        </>
      );
    }

    return (
      <div style={{ textAlign: 'center', margin: 'auto 0' }}>
        <CircularProgress />
      </div>
    );
  }

  return props.children || <></>;
};

export default LoadingContainer;
